import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import moment from 'moment'
import ErrorIcon from '@mui/icons-material/Error';
import NewsList from "../../common/NewsList";
import Loading from "../../../pages/error/Loading";
import {getRealtimeNewsAPI} from "../../../apis/news_service";
import {getNoneNewsMsg} from "../../../apis/my_service";
import more from "../../../assets/images/ico_more.svg";

const MycorpNewsList = ({targetStockname, targetCode}) => {
    const navigate = useNavigate();
    const today = moment()

    const [loading, setLoading] = useState(true)

    const [data, setData] = useState([]); //긍정 뉴스 리스트
    const [data_n, setData_n] = useState([]); // 부정 뉴스 리스트

    useEffect(() => {
        if (!!targetCode) {
            const params = {
                page: 1,
                startdate: today.format('YYYYMMDD'),
                stockcode: targetCode,
                signal: '긍정'
            };

            const params2 = {
                page: 1,
                startdate: today.format('YYYYMMDD'),
                stockcode: targetCode,
                signal: '부정'
            };
            getRealtimeNewsAPI(params).then(res => {
                setData(res)
                setLoading(false)
            })
            getRealtimeNewsAPI(params2).then(res => {
                setData_n(res)
                setLoading(false)
            })

        } else {
            getRealtimeNewsAPI().then(res => {
                setData(res)
            })
        }

        return () => setLoading(true)

    }, [targetStockname, targetCode])


    const goToStock = () => {
        const state = {news: {}}
        navigate(`/stock/${targetCode}`, {state: state})
    }
    const goToNews = (signal) => {
        const state = {stockname: targetStockname, signal: signal}
        navigate(`/news/${targetCode}`, {state: state})
    }

    const [curateMsg, setCurateMsg] = useState('')
    const getCurateMsg = () => {
        getNoneNewsMsg(targetStockname, targetCode).then(res => {
            setCurateMsg(res)
        })

        return <p className='sub_text'>{curateMsg}</p>
    }

    return (
        <>
            {
                loading ?
                    <Loading/>
                    :
                    data.length > 0 || data_n.length > 0 ?
                        <>
                            {data.length > 0 &&
                                    <div>
                                        <p className='title_md newslist_title'>
                                            {targetStockname}
                                            <span className='positive'> 긍정 뉴스 </span> 확인하기
                                        </p>
                                        <p className='sub_text' onClick={goToStock}>
                                            <span>기업보러가기</span>
                                            <img src={more} alt='more'/>
                                        </p>
                                        <NewsList newsList={data} type='vertical' size='5' main=''/>
                                        {data.length > 5 &&
                                            <button className='more_btn' onClick={() => goToNews('긍정')}>긍정 뉴스 더보기</button>}
                                    </div>
                            }
                            {data.length > 0 && data_n.length > 0 && <div className='divider'/>}
                            {data_n.length > 0 &&
                                <div>
                                    <p className='title_md newslist_title'>
                                        {targetStockname}
                                        <span className='negative'> 부정 뉴스 </span>확인하기
                                    </p>
                                    <p className='sub_text' onClick={goToStock}>기업보러가기 > </p>
                                    <NewsList newsList={data_n} type='vertical' size='5' main=''/>
                                    {data_n.length > 5 &&
                                        <button className='more_btn' onClick={() => goToNews('부정')}>부정 뉴스 더보기</button>}
                                </div>
                            }
                        </>
                        :
                        <div className='empty_container' style={{textAlign: 'center'}}>
                            <div><ErrorIcon sx={{fontSize: '73px', color: '#eee'}}/></div>
                            {/*<p className='sub_text'>*/}
                            {/*    오늘 {targetStockname} 뉴스가 보도되지 않았습니다.<br/>*/}
                            {/*    /!*마지막 뉴스는 2023년 05월18일 보도되었습니다.*!/*/}
                            {/*</p>*/}
                            {/*<p className='sub_text'>*/}
                            {/*    {targetStockname}가 속한 산업의 추천 뉴스는 N개가 있습니다.<br/>*/}
                            {/*    /!*반도체 테마의 추천 뉴스 N개가 있습니다.*!/*/}
                            {/*</p>*/}
                            {getCurateMsg()}
                            <button className='more_btn' onClick={goToNews}>다른날의 뉴스 보기</button>
                        </div>
            }
        </>
    );
};

export default MycorpNewsList;